<script setup lang="ts">
import { ref, reactive, computed, watch } from 'vue'
import { getLatestPopupData, newLinkPush, pushActivityEvent, resetObj, showImageUrl } from '@/utils'
import { store } from '@/pinia/store'
// types
import { PopupDataType } from './types.ts'

const storeData = store()
const timer = ref()
const showAgain = ref()
const showPopup = ref(false)
const popupData = reactive<PopupDataType>({})
const cssClass = computed(() => {
  if (popupData?.attr?.deliveryStyle && popupData?.attr?.deliveryStyle !== 'fixturefloating') {
    return `${popupData?.attr?.deliveryStyle}`
  }
  return ''
})

watch(
  () => storeData.showGlobalPopup,
  (n) => {
    clearTimeout(timer.value)
    clearTimeout(showAgain.value)
    const bodyDom = document.body
    // 页面切换逻辑暂停
    if (!storeData.isPageEnter) {
      showPopup.value = false
      return
    }
    // 当v2版本全局弹窗展示时当前弹窗不触发
    console.log('v2弹窗结果', storeData.v2PopupShowType)
    if (storeData.v2PopupShowType < 2) return
    console.log('当前弹窗数据', storeData.globalPopupList)
    const latestPopupData = getLatestPopupData(storeData.globalPopupList)
    console.log('筛出来的数据', latestPopupData)
    if (Object.keys(latestPopupData).length === 0) {
      storeData.showGlobalPopup = false
      showPopup.value = false
      return
    }
    if (n) {
      console.log('打开了')
      showPopup.value = true
      resetObj(popupData, latestPopupData)
      storeData.globalPopupList.map((x) => {
        if (x.ID === latestPopupData?.ID) {
          x.isExpired = true
        }
      })
      if (bodyDom && popupData?.attr?.deliveryStyle === 'middlefloating') {
        bodyDom.style.overflowY = 'hidden'
      }
      if (popupData?.attr?.displaySeconds > -1) {
        timer.value = setTimeout(
          () => {
            console.log('时间到了')
            storeData.showGlobalPopup = false
            showPopup.value = false
            bodyDom.style.overflowY = ''
          },
          (popupData?.attr?.displaySeconds > 0 ? popupData?.attr?.displaySeconds : 3) * 1000,
        )
      }
      pushActivityEvent(popupData)
    } else {
      console.log('关闭了')
      storeData.showGlobalPopup = false
      showPopup.value = false
      console.log(storeData.globalPopupList)
      if (bodyDom) {
        bodyDom.style.overflowY = 'hidden'
      }
      const nextPopupData = getLatestPopupData(storeData.globalPopupList)
      console.log('下一个弹窗数据', nextPopupData)
      if (Object.keys(nextPopupData).length > 0) {
        showAgain.value = setTimeout(() => {
          storeData.showGlobalPopup = true
        }, 1000)
      }
    }
  },
  {
    immediate: true,
  },
)

// 点击跳转逻辑
const clickJump = () => {
  if (!popupData?.link) return
  newLinkPush(popupData?.link)
}

// 关闭弹窗
const closeGlobalSocketPopup = () => {
  const bodyDom = document.body
  if (bodyDom) {
    bodyDom.style.overflowY = ''
  }
  storeData.showGlobalPopup = false
  showPopup.value = false
  resetObj(popupData, {})
}
</script>

<template>
  <transition name="fade">
    <div class="popup-container" :class="[cssClass]" v-if="showPopup">
      <div class="popup-con">
        <div class="popup-con--main flex_align_center">
          <GlobalImage class="popup-pic" :src="showImageUrl(popupData?.attr?.imageUrl)" @click.stop="clickJump"></GlobalImage>
        </div>
        <div class="popup-con--close" @click.stop="closeGlobalSocketPopup" v-if="popupData?.attr?.closeable === 1"></div>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.popup-container {
  width: 100%;
  height: 82px;
  position: fixed;
  left: 0;
  z-index: 1000;
  .popup-con {
    position: relative;
    &--main {
      justify-content: center;
      .popup-pic {
        width: 355px;
        height: 82px;
      }
    }
    &--close {
      width: 14px;
      height: 14px;
      background: url('@/assets/imgs/globalPopup/global_popup_clocse_01.png') center no-repeat;
      background-size: 100%;
      position: absolute;
      right: 6px;
      top: 6px;
    }
  }
  &.topfloating {
    width: 355px;
    left: 10px;
    top: 60px;
    border-radius: 12px;
    box-shadow: 0 6px 14px 0 rgba(34, 34, 34, 0.06);
  }
  &.middlefloating {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    .popup-con {
      height: 440px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      top: 50%;
      margin-top: -220px;
      &--main {
        width: 375px;
        height: 375px;
        .popup-pic {
          width: 375px;
          height: 375px;
        }
      }
      &--close {
        width: 35px;
        height: 35px;
        background-image: url('@/assets/imgs/globalPopup/global_popup_clocse_02.png');
        position: initial;
      }
    }
  }
  &.bottomfloating {
    bottom: 88px;
    border-radius: 12px;
    box-shadow: 0 6px 14px 0 rgba(34, 34, 34, 0.06);
    .popup-con {
      &--main {
        .popup-pic {
          width: 375px;
        }
      }
    }
  }
}
</style>
